"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORMATTED_AMOUNT_PATTERN = void 0;
exports.parseAmount = parseAmount;
exports.isPositiveAmount = isPositiveAmount;
/** Matches canonical amount strings stored by AmountInput (e.g. "1234.56"). */
exports.FORMATTED_AMOUNT_PATTERN = /^\d*(,\d{1,3})*(\.\d{1,2})?$/;
/**
 * Parses a formatted or raw amount string into a number.
 * Strips thousands separators before parsing so "1,234.56" → 1234.56.
 */
function parseAmount(value) {
    if (value === undefined || value === null || value === '') {
        return NaN;
    }
    const normalized = String(value).replace(/,/g, '').trim();
    if (normalized === '') {
        return NaN;
    }
    return parseFloat(normalized);
}
function isPositiveAmount(value) {
    const amount = parseAmount(value);
    return !Number.isNaN(amount) && amount > 0;
}
